import { transformImage } from '@/helpers/transforms'
import type { HeroImageBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import PageHeadSecondary from '../template-blocks/PageHeadSecondary'

export const HeroImageConverter: JSXConverter<SerializedBlockNode<HeroImageBlock>> = ({ node }) => {
	const { title, image } = node.fields
	const imageData = transformImage(image)

	return <PageHeadSecondary title={title} image={imageData} />
}
